exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trans-btn[data-v-b22ffe40]{width:30px;height:30px;background:transparent;border:none;display:flex;justify-content:center;align-items:center;padding:0;cursor:pointer;border-radius:5px;transition:background-color .25s ease-in-out}.trans-btn[data-v-b22ffe40]:hover{background-color:var(--color-secondary-extra-light);transition:background-color .25s ease-in-out}.trans-icon[data-v-b22ffe40]{height:auto;width:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b22ffe40","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/form/Translator.vue
// module id = 906
// module chunks = 0